// extracted by mini-css-extract-plugin
export default {"scrollToTop":"ScrollToTopButton_scrollToTop__KVfak","visible":"ScrollToTopButton_visible__dBN8H"};